import { render } from "./chat-support.vue?vue&type=template&id=d16387d6&scoped=true"
import script from "./chat-support.vue?vue&type=script&lang=js"
export * from "./chat-support.vue?vue&type=script&lang=js"

import "./chat-support.vue?vue&type=style&index=0&id=d16387d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16387d6"]])

export default __exports__